import React from "react";
import { Modal, Button } from "react-bootstrap";

const DefaultForm = (props) => {
  const { bodyChildren, footerChildren, ...modalProps } = props;
  return (
    <>
    <Modal {...modalProps} size={props.size} aria-labelledby="contained-modal-title-vcenter" centered dialogClassName={"modal-container"}>
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter" className="font-size-13">{props.title}</Modal.Title>
        <button
          type="button"
          className="custom-close-button modal-close-btn"
          aria-label="Close"
          onClick={props.onHide}
        >
          ✕
        </button>
      </Modal.Header>

      <Modal.Body style={{overflowX: 'auto'}}>
        {bodyChildren}
      </Modal.Body>
      
      <Modal.Footer>
        {footerChildren}
      </Modal.Footer>
    </Modal>
    </>
  )

}

export default DefaultForm;
